<template>
  <div class="dataFolder">
    <div v-for="item in fileList" class="file" @click="handleFile(item)">
      <div :class="[icons.get(item.type) ? 'fileImg' : '']" class="img">
        <img :src="icons.get(item.type)" alt="">
      </div>
      <div class="text">
        <div class="name">{{ item.name }}</div>
        <div class="bottom">
          <div class="size">{{ formatSize(item.size) }}</div>
        </div>
      </div>
    </div>
  </div>
  <van-image-preview v-model:show="state.showResourcePreview"
                     :closeable="true" :images="[state.resourceSrc]"
                     :showIndex="false">
  </van-image-preview>
</template>
<script setup>
import {icons} from "@/views/Doc/Space/data";
import {BlobToImg} from "@/utils/utils";
import {PreviewFile} from "@/api/doc";
import router from "@/router";
import {reactive} from "vue";
import {spaceStore} from "@/store/space";
import {storeToRefs} from "pinia";
import {DownLoadFiles} from "@/api/oaApi";

const props = defineProps({
  fileList: {
    type: Array,
    default: () => {
      return []
    }
  },
  isTask: {
    type: Boolean,
    default: false
  }
})

const space_store = spaceStore()
const {
  currentFolder,
  loading,
  finished,
  pageSize,
} = storeToRefs(space_store)

const state = reactive({
  resourceSrc: "",
  showResourcePreview: false,
  imgTypes: ["jpeg", "png", "gif", "bmp", "webp", "tiff", "icon", "svg", "jpg"],
  isImg: false
})

const handleFile = async (item) => {
  if (item.type === "文件夹") {
    const child = currentFolder.value.filter(folder => folder.id === item.id)[0]
    handleFolder(child)
  } else {
    await previewFile(item)
  }
}
// 格式化文件大小
const formatSize = (size) => {
  if (size < 1024) return size + ' B';
  else if (size < 1048576) return (size / 1024).toFixed(2) + ' KB';
  else if (size < 1073741824) return (size / 1048576).toFixed(2) + ' MB';
  else return (size / 1073741824).toFixed(2) + ' GB';
};

// 点击文件夹
const handleFolder = (item) => {
  space_store.handleFolder(item)
}

const previewFile = async (item) => {
  // 单独处理图片
  if (state.imgTypes.indexOf(item.extension) !== -1) {
    state.isImg = true
    let res
    if (props.isTask) {
      res = await DownLoadFiles({attachment_id: item.id})
      console.log(res, "res11111")
    } else {
      res = await PreviewFile(item.id)
      console.log(res, "res2222222")
    }
    // const res = await PreviewFile(item.id)
    state.resourceSrc = await BlobToImg(res, res.type)
    state.showResourcePreview = true
    return
  }
  // 其他的跳转到预览界面
  await router.push({
    name: 'SpacePreview',
    query: {
      id: item.id,
      isTask: props.isTask
    }
  })
}
</script>
<style lang="scss" scoped>
.dataFolder {
  overflow-y: scroll;
  width: 100%;

  &:after {
    content: "";
    flex: auto;
  }

  .img {
    display: flex;
    align-items: center;
  }

  .folder {
    display: flex;
    text-align: center;
    width: 100%;
    margin-bottom: 15px;

    &:last-child {
      margin-bottom: 0;
    }

    img {
      width: 25px;
    }

    .text {
      flex: 1;
      display: flex;
      align-items: center;
      text-align: left;
      padding-left: 10px;
    }
  }

  .file {
    border: 1px solid #A8ABB2;
    border-radius: 10px;
    display: flex;
    margin-bottom: 15px;

    &:last-child {
      margin-bottom: 0;
    }

    img {
      width: 25px;
      padding: 3px;
    }

    .text {
      flex: 1;
      display: flex;
      justify-content: center;
      flex-direction: column;
      text-align: left;
      padding-left: 10px;

      .name {
        font-size: 12px;
        margin-bottom: 3px;
      }
    }

    .bottom {
      color: #8f8f8d;
      display: flex;
      margin-right: 5px;
      font-size: 9px;

      .time {
        margin-right: 5px;
      }
    }
  }
}
</style>